// extracted by mini-css-extract-plugin
module.exports = {"container":"Loader_container__3D3dj","sk-bouncedelay":"Loader_sk-bouncedelay__rVmpj","bounce1":"Loader_bounce1__2CRBK","bounce2":"Loader_bounce2__qpnGa"};